/** App API del módulo Catálogo — hooks, use cases, overlay store, navigation.
 * Importar desde acá para evitar require cycles. */

export {
  ImportProductFromRemoteValidationError,
} from './application/importProductFromRemoteSuggestion';

export {
  importProductFromRemoteSuggestion,
} from './application/importProductFromRemoteSuggestion';

export {
  assertWithinProductPlanLimit,
  CatalogPlanLimitExceededError,
  getCatalogPlanLimitExceededMessage,
} from './application/catalogPlanLimits';

export { useCatalogListController } from './application/useCatalogListController';
export { useProductVariantsEnabled } from './application/useProductVariantsEnabled';
export { useMenuModifiersEnabled } from './application/useMenuModifiersEnabled';

export { bulkPreviewScopeHint, bulkAllCatalogWarning, isBulkPreviewScopeAllowed } from './application/bulkPreviewScope';

export {
  DEFAULT_BULK_CATEGORY_SCOPE,
  bulkCategoryScopeFromCatalogFilter,
  bulkCategoryScopeModeLabel,
  type BulkCategoryScope,
} from './application/bulkCategoryScope';

export {
  BULK_COEFFICIENT_PREVIEW_FETCH_LIMIT,
  BULK_COEFFICIENT_PREVIEW_PAGE_SIZE,
} from './application/bulkCoefficientConstants';

export {
  DEFAULT_BULK_PRICE_ROUNDING,
  applyBulkPriceRounding,
  computeBulkPriceAfterCoefficient,
} from './application/bulkPriceRounding';
export type { BulkPriceRounding } from './application/bulkPriceRounding';

export {
  useCatalogOverlayStore,
  resetCatalogTabOverlays,
} from './store/useCatalogOverlayStore';
export type { CatalogProductFormMode } from './store/useCatalogOverlayStore';

export { openCatalogNewService, openCatalogNewProduct, openCatalogMasters } from './application/catalogNavigation';
export type { CatalogMastersSection } from './application/catalogNavigation';
